export default __webpack_public_path__ + "static/media/pc-piramide-2.521273ef.webp";